/***
 *
 *   STATUS BADGE
 *   Displays Active or Cancelled account status.
 *
 *   PROPS
 *   active: boolean | 0 | 1
 *
 ***/

import Style from './status-badge.tailwind.js';

export function StatusBadge({ active }) {
  if (active === null || active === undefined) {
    return <span className={`${Style.base} ${Style.unknown}`}>—</span>;
  }
  const isActive = active === true || active === 1;
  return (
    <span className={`${Style.base} ${isActive ? Style.active : Style.cancelled}`}>
      {isActive ? 'Active' : 'Cancelled'}
    </span>
  );
}
